import authRules from '../authRules';

const addTour = (user) => {
  const { tour } = user.securityLevels;
  if (tour >= authRules.addTour.tour) {
      return true;
  } else {
      return false;
    }
  }


export default addTour;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/addTour.js